import React, { useContext, useState, useRef } from "react";
import { UserContext } from "../../providers/UserProvider";
import { firestore } from "../../firebase";
import NavBar from "../../components/NavBar";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";

import "./style.css";

const UserInbox = () => {
  const user = useContext(UserContext);
  const [userData, setUserData] = useState("");
  const [myInboxData, setMyInboxData] = useState("");
  const userRef = firestore.collection("usersData");
  const inboxRef = firestore.collection("usersInbox");
  const inboxDocTemp = [];

  React.useEffect(() => {
    userRef
      .doc(user.uid)
      .get()
      .then((doc) => {
        if (doc.exists) {
          let data = doc.data();
          setUserData(data);
        } else {
          // doc.data() will be undefined in this case
          setUserData(null);
          console.log("No such document!");
        }
      })
      .catch(function (error) {
        setUserData(null);
        console.log("Error getting document:", error);
      });
  }, []);

  React.useEffect(() => {
    inboxRef
      .where("receivingUser", "==", user.uid)
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          inboxDocTemp.push(doc.data())
        });
        setMyInboxData(inboxDocTemp);
      })
      .catch(function (error) {
        console.log("Error getting documents: ", error);
      });
  }, []);

  if (!userData || !myInboxData) return <div>Loading Data</div>;

  const sections = [
    { title: "פרופיל", url: "/Profile" },
    { title: "אח בוגר", url: "#" },
    { title: "פורום מקצועי", url: "#" },
    { title: "הפניות תיקים", url: "/SearchLead" },
  ];

  // const openInbox = () => {
  //   try {
  //     await userRef.doc(user.uid).update({numberOfUnreadInboxes: decrementFbInstanceBy1})
  //     } catch (error) {
  //       console.error("Error Updating numbOfUndreadInboxes In Database", error);
  //     }
  // }
  return (
    <div>
      <CssBaseline />
      <Container maxWidth="lg">
        <NavBar sections={sections} />
      </Container>
      <hr />

      <div className="myleads-page-cards-wrapper">
        {myInboxData.map((inbox) => (
          <div>hi</div>
        ))}
      </div>
    </div>
  );
};

export default UserInbox;
